import React from 'react'
import { bool, func } from 'prop-types'
import {
  ButtonPrimaryWithArrow,
  ButtonPrimaryArrowOnly,
} from '@creditas-ui/react'
import i18n from '~i18n/i18n'

export const NextButton = ({
  isMobile,
  isHidden,
  isValid,
  loading,
  onClick,
}) => {
  if (isHidden) {
    return null
  }

  if (isMobile) {
    return (
      <ButtonPrimaryArrowOnly
        data-testid="next-button"
        aria-label={i18n.t('commons:buttons.next_step')}
        loading={loading}
        onClick={onClick}
        size="large"
        disabled={!isValid}
      />
    )
  }

  return (
    <ButtonPrimaryWithArrow
      data-testid="next-button"
      aria-label={i18n.t('commons:buttons.next_step')}
      loading={loading}
      onClick={onClick}
      size="large"
      disabled={!isValid}
    >
      {i18n.t('commons:buttons.continue')}
    </ButtonPrimaryWithArrow>
  )
}

NextButton.propTypes = {
  isMobile: bool.isRequired,
  isHidden: bool.isRequired,
  isValid: bool.isRequired,
  loading: bool.isRequired,
  onClick: func.isRequired,
}
